module.exports = __webpack_public_path__ + "98c4c3630e768a9d53515d12723357a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/step2.png
// module id = 870
// module chunks = 3